import React, { useCallback, useMemo } from "react";
import Button from "@ls/react-button";
import { toggleDrawer } from "state/app/actions";
import { batch, useDispatch, useSelector } from "react-redux";
import SelectionState from "state/selections/SelectionState";
import { isDefined } from "@ls/js-utils";
import {
  selectSelectedAsOfDate,
  selectSelectedAsOfDateStart,
  selectSelectedGroupTypeValue,
  selectSelectedGroupValues,
  selectSelectedEntityIds,
  selectModeValue,
} from "state/selections/selectors";
import { commitSelections } from "state/selections/actions";
import { startRequests } from "state/app/actions";
import {setDefinitions} from "state/tradehistoryAttributes/actions";
import {useColumnDefinitions } from "state/grid";
import Mode from "state/selections/Mode";

const GoButton = (props) => {
  const dispatch = useDispatch();

  const groupType = useSelector(
    selectSelectedGroupTypeValue(SelectionState.UNCOMMITTED)
  );

  const groups = useSelector(
    selectSelectedGroupValues(SelectionState.UNCOMMITTED)
  );

  const asOfDate = useSelector(
    selectSelectedAsOfDate(SelectionState.UNCOMMITTED)
  );

  const asOfDateStart = useSelector(
    selectSelectedAsOfDateStart(SelectionState.UNCOMMITTED)
  );

  const entityIds = useSelector(
    selectSelectedEntityIds(SelectionState.UNCOMMITTED)
  );

  const mode = useSelector(selectModeValue(SelectionState.UNCOMMITTED));

  const disabled = useMemo(() => {
    if (mode === Mode.ACC_GROUPS) {
      return (
        !isDefined(groupType) ||
        !isDefined(groups) ||
        !isDefined(asOfDate) ||
        !isDefined(asOfDateStart)
      );
    }
  }, [groupType, groups, asOfDate, asOfDateStart, mode]);

  const columnDefssss = useColumnDefinitions();
  const onButtonClick = useCallback(() => {
    
    batch(() => {
      dispatch(toggleDrawer());
      dispatch(setDefinitions(columnDefssss));
      dispatch(commitSelections());
      dispatch(startRequests());
    });
  }, [dispatch, columnDefssss]);

  const tooltip = useMemo(() => {
    if (disabled) {
      const missing = [];
      if (mode === Mode.ACC_GROUPS) {
        if (!isDefined(groupType)) {
          missing.push("Group Type");
        }
        if (!isDefined(groups) || groups.length === 0) {
          missing.push("Groups");
        }

        if (!isDefined(asOfDate)) {
          missing.push("As of date");
        }
      }
      if (mode === Mode.ENTITIES && !entityIds?.length) {
        missing.push("Entities");
      }

      return `Missing input: ${missing.join(", ")}`;
    }
  }, [disabled, groupType, groups, asOfDate, mode, entityIds]);

  return (
    <Button
      onButtonClick={onButtonClick}
      label="Go"
      disabled={disabled}
      tooltip={tooltip}
      variation={3}
    />
  );
};

export default GoButton;
